// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> v-esprit
// Generated: 2026-10-08T21:16:46.535Z
// Counts: 1 design, 66 content, 33 slot group, 4 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span>, a 55+ Active Adult Community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs. Complete the application below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At V Esprit in Aurora, CO, vibrant living meets convenience. Step outside your new home to enjoy nearby gems like the Museum of Outdoor Arts. From parks to top-tier fitness centers, the best local attractions await just beyond your doorstep. See what’s around our community today!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166803/01a0f8c9-221f-7498-be1f-ab85f7304521.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-4de6-72a8-b209-bcc36ed5c586.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community dining area with a large table and chairs, adjacent to a bar and kitchen."
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-3e62-74eb-9d2b-62e4a2dd1cfd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Well-equipped fitness center with treadmills, ellipticals, and weight machines overlooking scenic views."
      }
    }
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-fab9-761b-9a9c-03427df0e98e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living and dining area with a sofa, chairs, dining table, and fireplace."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-a6f6-718b-9f6f-922eb71d5fc5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of the property entrance with a covered walkway, landscaping, and parking lot."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-0c87-71e2-8c4e-f71ad75843ea.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-concept kitchen and living area with island and dining table."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-712f-732d-82ca-91bdc4c8df22.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with fireplace and large windows."
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-4ad9-76ab-b29e-0b720d0617ce.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a sprawling multifamily property with various buildings, green spaces, and distant mountains."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-e802-741c-9647-6d7fd1910367.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial site view of the V Esprit community showing apartment buildings, landscaped grounds, and parking areas in Aurora, CO."
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-a8f7-7245-ab77-d52f03bc2d72.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the V Esprit community set within its Aurora neighborhood, with surrounding homes and the distant Denver skyline."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-92dc-71f5-b8eb-e258b2b7cede.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor patio with seating and tables, surrounded by a red railing, with buildings and trees in the background."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-231d-7719-9c51-0e20805a5242.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor putting green and bocce ball court with seating and patio furniture under red umbrellas."
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-609b-765d-83ae-d5da0a72e01d.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-09e6-7228-b997-992d06995384.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-fca2-7128-9671-14629810e1cf.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-126f-7073-997d-915486e457f7.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-1e2f-7329-87b7-b9ab3a794b2c.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-3e62-74eb-9d2b-62e4a2dd1cfd.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-b7c3-732a-843a-6d1fff20aa39.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-4ad9-76ab-b29e-0b720d0617ce.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-998c-772f-ac13-9d62de64c020.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior of a multi-story apartment building lobby with seating areas and large windows overlooking a landscape."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-bb7e-765d-8f8b-36e6d3b46183.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Comfortable seating area in the community lounge with a sofa, armchairs, coffee table, and artwork."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-2db0-712a-958e-06cb44d614d0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a fireplace and large windows."
      }
    }
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1e-5086-7168-916c-15d897686311.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of apartments with landscaping and blue sky."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1d-9958-71f7-a6c0-d17890f8544f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "V Esprit apartment building with a welcoming covered entrance glowing warmly at sunset."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166793/019fba1f-b7c3-732a-843a-6d1fff20aa39.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with white leather sofa, striped armchairs, coffee table, and large windows."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": [
      "custom_f7f27755-ad27-41fe-9942-1f877d65c9e4",
      "custom_29ebf607-49bd-4fb9-9dcd-c6d7747a0f60",
      "custom_50804105-7dc7-4bc8-a789-7c5e5e4b0b38",
      "custom_97df3c8b-511a-4b61-8ab0-a11523eb0d4b",
      "custom_8845e652-8073-4dcc-a1ad-93dd362b83e2",
      "custom_a420a340-cbf4-46f9-b797-207ff9712528",
      "custom_c7d98390-11fb-4c79-828d-b24069f7bf6e",
      "custom_9cd1367c-0bf6-42c0-be9e-b043cc4105d9",
      "custom_9a28b1ba-131c-41e3-92fa-5d9e9aaf7361",
      "custom_ef478be1-c101-4a81-b475-c28b55d1c72c",
      "custom_160b2c8e-870b-48cc-819a-46b6c9603ec4",
      "custom_705e413d-c053-43a3-865e-4691bc59147e",
      "custom_8fb958ea-8564-4e65-a490-75be17af79cb",
      "custom_5865107b-1b0c-4139-8252-e57e7b569026",
      "custom_81291244-f967-4b12-9dfc-ec1e7a064986",
      "custom_9399f7df-df16-41fe-9f2f-d84ba6b81a7b",
      "custom_02cf8a1b-9b95-4a48-ae54-cfd3b9062637",
      "custom_9ba98d37-9dd4-408c-84a3-0823f595712c",
      "custom_03359920-9163-44e0-94b3-299b7427fde8",
      "custom_f1dea984-bf7d-4f65-b2aa-133dfa3471e5"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_201bb7b1-643b-421a-a405-c1663e91bc8b",
      "custom_4a5252de-15ad-4559-89e4-0b2423a6fbd0",
      "custom_1f937a57-0db6-4b3a-8121-37734f150dc5",
      "custom_352f7e25-282f-4c2d-b936-09cbaf6f22dd",
      "custom_ccc40e01-b2c3-4c22-89d4-77f55ef2a5e5",
      "custom_ec29b3f3-78a1-498b-b0bf-4c6d768843e2",
      "custom_2e48861a-b5a6-4e27-9fe2-14617a55c217",
      "custom_80e03c05-9312-47e0-8203-3ba20c5954fa",
      "custom_b4522bed-8fe4-479b-ba25-83bee19161c4",
      "custom_907c3a96-3aac-4f32-b563-ebec55822c7e",
      "custom_a6b5342e-003a-481b-85dd-783e9d8db7b6",
      "custom_8cddaa0e-4847-4b32-a900-4fe1ea813be1",
      "custom_3a2dd010-07d6-4fee-887e-4c038671e49c",
      "custom_3356c00d-4b04-4372-b115-ca661932aa93",
      "custom_5f17701c-a605-46f3-b659-0db52ed533e2",
      "custom_19824c53-0582-491b-a3b6-cdce84ed1456",
      "custom_c9e3fe51-fde7-4b31-9a40-771d55532782",
      "custom_b9803a69-fe1e-4adc-b626-c829ba00938f",
      "custom_11bfbf32-fb71-409d-8b63-70feac0875b2",
      "custom_0482f27a-862b-4f51-b422-29e7fc259c5b",
      "custom_72d1c307-5e17-4118-b641-7f0821438a32",
      "custom_68bef250-10ee-49dd-9c93-7f3822ec2595",
      "custom_50510014-849f-4799-9eac-90a4dc02354e",
      "custom_b3a6c014-c353-4e60-8555-6f67b9e8a293",
      "custom_eb3d957c-269d-4b26-b740-1e7064dd8f8e",
      "custom_9c386d79-aa23-42d8-a346-88bbc501edb8",
      "custom_790899d0-5252-49b7-ae9a-9b15331fbe28",
      "custom_63ba68cd-1fb5-4777-be10-920fc5435e43",
      "custom_09c7bfd9-f39a-420a-8711-d277dcd8a424",
      "custom_ec893499-3a60-41c1-bb5b-fc06edc11d7c"
    ],
    "orderedIds": [
      "custom_bc67951e-8df1-4c62-8273-91a1b6999958",
      "custom_0048a540-a015-4905-8cf4-387ce9bf9c76",
      "custom_e8fbccd9-566b-4302-a759-4343e369f7ff",
      "custom_6285e4fd-380d-4e49-b8b0-5cc575248418",
      "custom_f32eb501-e002-4528-b77b-3cf070fb0266",
      "custom_ec893499-3a60-41c1-bb5b-fc06edc11d7c",
      "custom_4a45c511-0e00-4113-8201-70d09c22829c",
      "custom_1f937a57-0db6-4b3a-8121-37734f150dc5",
      "custom_19824c53-0582-491b-a3b6-cdce84ed1456",
      "custom_0482f27a-862b-4f51-b422-29e7fc259c5b",
      "custom_8cddaa0e-4847-4b32-a900-4fe1ea813be1",
      "custom_b9803a69-fe1e-4adc-b626-c829ba00938f",
      "custom_11bfbf32-fb71-409d-8b63-70feac0875b2",
      "custom_c9e3fe51-fde7-4b31-9a40-771d55532782",
      "custom_4a5252de-15ad-4559-89e4-0b2423a6fbd0",
      "custom_a7e770f7-b318-4cba-9eb2-e83c0825fc1b",
      "custom_0bb7ea9c-9679-491a-b0ae-3241635bd994",
      "custom_50510014-849f-4799-9eac-90a4dc02354e",
      "custom_63ba68cd-1fb5-4777-be10-920fc5435e43",
      "custom_96a681ea-5322-4c88-b84b-ed103a2439a1",
      "custom_a6b5342e-003a-481b-85dd-783e9d8db7b6",
      "custom_27f0b41e-7f63-429e-ae97-da57fa219ab4",
      "custom_0b683590-6dac-4d9a-b5a6-65a29bcb11ba",
      "custom_7da6a6af-e26a-4590-a9a9-5daabc923d2a",
      "custom_b38406b8-d8f8-4f0a-9e44-2b210f1f07cd",
      "custom_49ade874-c634-4a17-9c49-2412a486f156",
      "custom_9cf4f0e9-8c10-4ff8-b3aa-9d8ef347b343",
      "custom_68bef250-10ee-49dd-9c93-7f3822ec2595",
      "custom_1704a66c-31a4-4d44-9acb-50c38674fbb3",
      "custom_6104ecd4-b581-4133-bfcd-2fea3c7c9e95",
      "custom_cb384151-e7eb-4e62-8a39-e6cc2f2b4fb9",
      "custom_fe9d84d5-9fbc-424c-bb32-2965d7ff2fda",
      "custom_139b0638-4312-44fb-a74c-59aa2fffa3bc",
      "custom_2f4051ee-2a1b-4dfd-ae7f-44ad072568d3",
      "custom_eeaa80ff-5edc-4fd4-b878-8e31be5432fc",
      "custom_4fc91413-202e-4561-9486-a5d32a286133",
      "custom_95671062-55ae-48ff-8f98-937e1cd7955f",
      "custom_e929ff4d-9a2e-4fa3-a820-6457b8d0b206",
      "custom_72d1c307-5e17-4118-b641-7f0821438a32",
      "custom_7a38e1f0-1d6b-4962-b483-d8d7c91eac29",
      "custom_efdc7bb9-99e2-47c2-8c9e-b25fcdecaa35",
      "custom_b0032ab4-0b63-4f64-be84-8adfc9013cb2",
      "custom_63bc1d19-41b8-4f4c-920d-90104530e212",
      "custom_eb3d957c-269d-4b26-b740-1e7064dd8f8e",
      "custom_0bc05070-99cc-4717-a659-e316df6f4583",
      "custom_4a2edefe-f0b6-4b16-ad97-637691b52fe4",
      "custom_a5f0ac34-6046-41d9-b7e0-73cc393064d2",
      "custom_e893c2f1-32aa-4e34-b072-a0d6b9442de3",
      "custom_12b099f3-6f6f-415d-8daa-4dd0cf6adaad",
      "custom_d205887a-5a60-4c90-8969-d920abdbfb11",
      "custom_da6d8f38-d98b-48bd-9e76-950db7910bae",
      "custom_393a14f5-83eb-4545-a465-954f641ffb70",
      "custom_12c2b168-8095-45bc-8e77-f519e874cbb8",
      "custom_5a616073-8cc5-4cd9-bbdb-668f7a2e8ce4",
      "custom_045773f9-83eb-49b5-8683-a343bd238136",
      "custom_dfd90738-e6bf-48f2-9e7b-d968eb6c49bc",
      "custom_23af444c-8cbd-48f8-8cee-d1b4dde64271",
      "custom_5f17701c-a605-46f3-b659-0db52ed533e2",
      "custom_790899d0-5252-49b7-ae9a-9b15331fbe28",
      "custom_3356c00d-4b04-4372-b115-ca661932aa93",
      "custom_88f2d8c2-65bd-4e14-9ec8-4e0a48fcefa6",
      "custom_343bbaa7-c8c7-466f-90a0-dddde49bb9e8",
      "custom_4f56b49d-9e6d-4acf-99f3-0437b3e18d48",
      "custom_714997f1-f474-42f9-b887-58644f25f7d6",
      "custom_de7f6ec2-fd34-45b5-b90b-e54e9f9b9da6",
      "custom_1a2e35c4-b40d-4b0e-8f1e-574cd06c2841",
      "custom_80e03c05-9312-47e0-8203-3ba20c5954fa",
      "custom_e4c11388-5d69-451a-8d90-a7f8ae4aa756",
      "custom_d6e02bfb-5d13-411d-a832-a63ea33534d3",
      "custom_f4022076-024f-4523-aed5-920e240cded5",
      "custom_ff57773c-6f9b-4365-a8f3-8a13eb71a08c",
      "custom_b4522bed-8fe4-479b-ba25-83bee19161c4",
      "custom_742bbf51-f6a2-42dd-8963-069810b5b7df",
      "custom_acc19e58-5c41-4443-89f3-2f04e36ace93",
      "custom_352f7e25-282f-4c2d-b936-09cbaf6f22dd",
      "custom_0b99a5d4-9afb-49ba-9638-4de6dba2b818",
      "custom_3a2dd010-07d6-4fee-887e-4c038671e49c",
      "custom_907c3a96-3aac-4f32-b563-ebec55822c7e",
      "custom_216c21e6-122a-4fd3-8d4a-489dbd007558",
      "custom_67687e9d-3f9b-4143-a997-b24bd1d03e94",
      "custom_671aaf31-e800-40c1-96eb-f0e4acb52897",
      "custom_6a74d16c-0b1b-4eaa-8546-67908852d41b",
      "custom_ad8b1f5f-cc08-41c1-bd90-f238a653512a",
      "custom_ccc40e01-b2c3-4c22-89d4-77f55ef2a5e5",
      "custom_2bd0f354-507b-4933-b56d-bab471fb6d70",
      "custom_09c7bfd9-f39a-420a-8711-d277dcd8a424",
      "custom_2e48861a-b5a6-4e27-9fe2-14617a55c217",
      "custom_0a88ee80-6821-48d7-b0d7-2b16eb3193b7",
      "custom_ff05cd1a-5ac7-439a-aa2f-346bf82478de",
      "custom_8f88a9fd-ed5c-4d3b-ae04-37b70bba7179",
      "custom_3784e832-c549-4699-812e-7e4b0a3b41eb",
      "custom_279410f2-57d2-4850-9831-397701021db1",
      "custom_29e80c52-ef4c-4304-96f8-e196967c3c57",
      "custom_2e1bb4ff-68dc-40d0-9935-20640172d214",
      "custom_9c386d79-aa23-42d8-a346-88bbc501edb8",
      "custom_201bb7b1-643b-421a-a405-c1663e91bc8b",
      "custom_95671d7f-490c-479a-b8a3-733940755432",
      "custom_96973c67-7c4d-4900-9775-f224e2e17b05",
      "custom_b3a6c014-c353-4e60-8555-6f67b9e8a293",
      "custom_ec29b3f3-78a1-498b-b0bf-4c6d768843e2"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
